import * as types from '../actions/actionTypes';
import initialState from './initialState';
    
export default function genericReducer(state = initialState.results, action) {

  switch (action.type) {

    case types.REQUEST:
      action.data.secToken = sessionStorage.getItem('token');
      action.data.userID = sessionStorage.getItem('userID'); 
      let funcName = (action.data.altName)?action.data.altName: action.data.func;
      let queryCount = (state.queryCount)?state.queryCount:1;
      if(action.data.numQueries)
        queryCount =action.data.numQueries;
      //let chainLoaded = [];
      return {
        ...state, queryCount, //chainLoaded,
        [funcName]: {isLoaded: false}
      };         

    case types.INTERNAL_UPDATE:
      return {
        ...state, 
        [action.key]: action.value
      };  

    case types.DELETETHIS:
      let newState = {...state};
      delete newState[action.key];
      return newState;

    case types.SUCCEEDED:
      if(!action.result.response.revised || action.result.response.error){
        console.log('response',action.result.response);
        let data = {data:[], isLoaded:false};
        if(action.result.response.error)
          return {error:action.result.response.error, [action.result.funcName]:data};
        return {error: JSON.stringify(action.result.response), [action.result.funcName]:data};
      }
      let session = (action.result.response.revised)?
      action.result.response.revised:
      action.result.response;

      (action.result.response.revised)?
        sessionStorage.setItem('token',action.result.response.revised):
        sessionStorage.setItem('token',action.result.response);

      if(action.result.response) 
        delete action.result.response.revised;
      
      let result={
        isLoaded: true,
        data: action.result.response
      };

      let minusCount = state.queryCount-1;
      return {
        ...state, queryCount:(minusCount<0)?0:minusCount,
        [action.result.funcName]: result
      };         

    default:
      return state;
  }
}